/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class notebookss extends IceEntity {
  nb_ss_key: string = "";

  constructor(attr: any = {}) {
    super();
    for (let colName of Object.keys(attr)) {
      if (attr[colName] == null) continue;
      this.attributes[colName] = attr[colName];
    }
  }

  public gettablename(): string {
    return "NBSS";
  }
}
